import { useState } from "react";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";

const ArticleIcon = () => (
    <span
        className="material-icons-outlined"
        style={{
            fontSize: 18,
            width: 18,
            height: 18,
            color: "#475569",
            flexShrink: 0,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        article
    </span>
);

/**
 * Sources Popover — Figma Node 206-8441.
 * Replaces the previous Dialog with a compact Popover.
 */
export default function SourcesDialog({ sources = [], renderTrigger, disabled }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    if (!sources.length) return null;

    return (
        <>
            {/* Render custom trigger from parent */}
            {renderTrigger && renderTrigger(handleClick)}

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left", // Align left edge of popover with left edge of button?
                    // Figma design screenshot 1085 shows popover above buttons, aligned... 
                    // Actually, let's try top-left or top-center.
                    // Given it's a list, probably "bottom-left" of the button opens the popover?
                    // Or "top-left" if button is at bottom?
                    // In AIAnswerCard, buttons are at bottom. Popover should likely open UPWARDS (above button).
                    // So anchorOrigin vertical: 'top', transformOrigin vertical: 'bottom'.
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "6px",
                            boxShadow:
                                "0px 0px 2px 0px rgba(0,0,0,0.1), 0px 2px 4px 0px rgba(0,0,0,0.1)",
                            backgroundColor: "#fbfaf9", // neutral/faint
                            p: "4px", // gap/padding for list
                            mt: -1, // slight offset?
                        },
                    },
                }}
            >
                <List sx={{ p: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
                    {sources.map((source, index) => {
                        const href = source.url || null;
                        const listItemSx = {
                            borderRadius: "6px",
                            p: "8px",
                            gap: "8px",
                            minHeight: "auto",
                            "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                        };
                        return (
                            <ListItemButton
                                key={source.id ?? source.kb_id ?? index}
                                component={href ? "a" : "div"}
                                href={href || undefined}
                                target={href ? "_blank" : undefined}
                                rel={href ? "noopener noreferrer" : undefined}
                                onClick={handleClose}
                                sx={{
                                    ...listItemSx,
                                    ...(href && { textDecoration: "none", color: "inherit" }),
                                }}
                            >
                                <ArticleIcon />
                                <Typography
                                    sx={{
                                        fontFamily: "'Inter', sans-serif",
                                        fontSize: 14,
                                        fontWeight: 400,
                                        lineHeight: "20px",
                                        color: "#3d3a37",
                                    }}
                                >
                                    {source.title ?? source.name}
                                </Typography>
                            </ListItemButton>
                        );
                    })}
                </List>
            </Popover>
        </>
    );
}
